export default {"src":"/_next/static/media/starBlack.7d616bd7.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};